// extracted by mini-css-extract-plugin
export var container = "_5c-0";
export var infoButton = "_5c-1";
export var label = "_5c-3";
export var labelExpanded = "_5c-4";
export var price = "_5c-5";
export var priceExpanded = "_5c-6";
export var title = "_5c-2";